import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ImagesEndpoint, Url } from "../../Type/BaseUrl";

const ImageService = createApi({
    reducerPath: "ImageService",
    baseQuery: fetchBaseQuery({
        baseUrl: Url,
    }),
    endpoints: (builder) => {
        return {
            imageContent: builder.query({
                query: () => {
                    return {
                        url: ImagesEndpoint,
                        method: "GET",
                    };
                },
            }),
        };
    },
});
export const { useImageContentQuery } = ImageService;
export default ImageService;
